import { defineStore } from 'pinia'
import type MyArticle from '@/models/myArticle'
import utils, { isDefined } from '@/services/utils'
import type FavoriteTag from '@/models/favoriteTag'
import SimpleFavoriteTag from '@/models/simpleFavoriteTag'

// TODO: Will see and combine it to browse by store
export const useArticleStore = defineStore({
  id: 'articlesStore',
  state: () => ({
    articles: [] as MyArticle[],
    articlesIndexMap: new Map<string, number>(),
  }),
  actions: {
    setArticles(articles: MyArticle[]) {
      this.articles = articles
      this.generateMap()
    },
    generateMap() {
      this.articlesIndexMap.clear()
      this.articles.forEach((art, index) => {
        this.articlesIndexMap.set(art.CatalogArticleId, index)
      })
    },
    getArticle(catalogArticleId: string) {
      const index = this.articlesIndexMap.get(catalogArticleId)
      if (index !== undefined) {
        return this.articles[index]
      }
    },
    getArticles(catalogArticleIds: string[]) {
      const articles: MyArticle[] = []
      catalogArticleIds.forEach((catalogArticleId) => {
        const article = this.getArticle(catalogArticleId)
        if (article) {
          articles.push(article)
        }
      })
      return articles
    },
    addArticle(newArticle: MyArticle) {
      this.articles.push(newArticle)
      this.articlesIndexMap.set(newArticle.CatalogArticleId, this.articles.length - 1)
    },
    updateArticle(catalogArticleId: string, updatedArticle: MyArticle) {
      const index = this.articlesIndexMap.get(catalogArticleId)
      if (index !== undefined) {
        // this.articles[index] = updatedArticle
        this.articles.splice(index, 1, updatedArticle)
      }
    },
    updateArticleBulk(articles: MyArticle[]) {
      articles.forEach((article) => {
        this.updateArticle(article.CatalogArticleId, article)
      })
    },
    addOrUpdateArticle(article: MyArticle) {
      const index = this.articlesIndexMap.get(article.CatalogArticleId)
      if (index !== undefined) {
        // this.articles[index] = article
        this.articles.splice(index, 1, article)
      }
      else {
        this.addArticle(article)
      }
    },
    deleteArticle(catalogArticleId: string) {
      const index = this.articlesIndexMap.get(catalogArticleId)
      if (index !== undefined) {
        this.articles.splice(index, 1)
        this.generateMap()
      }
    },
    sortArticles() {
      this.articles = utils.sortMyArticles(this.articles)
      this.generateMap()
    },
    async updateFavTags(favoriteTags: FavoriteTag[], sharedFavoriteTags: FavoriteTag[]) {
      const indexedFavoriteTags = favoriteTags.reduce<Record<string, FavoriteTag[]>>((acc, tag) => {
        tag.Articles?.forEach((articleId) => {
          const key = `${tag.CatalogCode}//${articleId}`
          if (!acc[key]) { acc[key] = [] }
          acc[key].push(tag)
        })
        return acc
      }, {})

      sharedFavoriteTags.forEach((sharedFavoriteTag) => {
        if (sharedFavoriteTag.Articles && sharedFavoriteTag.Articles.length) {
          sharedFavoriteTag.Articles.forEach((articleId) => {
            const key = `${sharedFavoriteTag.CatalogCode}//${articleId}`
            if (!indexedFavoriteTags.hasOwnProperty(key)) {
              indexedFavoriteTags[key] = []
            }
            indexedFavoriteTags[key].push(sharedFavoriteTag)
          })
        }
      })
      this.articles.forEach((art) => {
        const favoriteTagKey = `${art.CatalogCode}//${art.Id}`
        art._FavoriteTags = isDefined(indexedFavoriteTags[favoriteTagKey]) ? indexedFavoriteTags[favoriteTagKey].map(itm => new SimpleFavoriteTag(itm.Id, itm.Tag, itm.Color, itm.CreatedByUserName, itm.CustomerId, itm.SharedUsers, itm.SharedUsersGroups)) : []
      })
    },
  },
})
